import React, { useState,useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';

import {
  AppBar, Toolbar, Typography, Container, CssBaseline, ThemeProvider,
  Box, Stepper, Step, StepLabel, TextField, Link, Paper, Button,
  CircularProgress, List, ListItem, ListItemIcon, ListItemText, Avatar,
  Divider, MenuItem, Checkbox, FormControlLabel,
} from '@mui/material';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import WcIcon from '@mui/icons-material/Wc';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import BadgeIcon from '@mui/icons-material/Badge';
import SchoolIcon from '@mui/icons-material/School';
import {
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Phone as PhoneIcon,
  Fingerprint as FingerprintIcon,
  Home as HomeIcon,
 } from '@mui/icons-material';
import { createTheme } from '@mui/material/styles';
import logo from '../logo.png';
import './styles.css';
import Footer from '../pages/Footer';
import { v4 as uuidv4 } from 'uuid';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64url';
import axios from 'axios';
import { faker } from '@faker-js/faker';
import { Card, CardContent } from '@mui/material';
import { Snackbar, Alert as MuiAlert } from '@mui/material';
import { Collapse, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

 

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(18,82,166)',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});

const steps = [
  'Provide Username',
  'Verify Fayda ID',
  'Review Fayda Profile',
  'Update Preference',
  'Complete Payment and Registration',
];

export default function SignIn() {
  const [activeStep, setActiveStep] = useState(0);
  const [username, setUsername] = useState('');
  const [userInfo, setUserInfo] = useState({examcenter: ''});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [consentChecked, setConsentChecked] = useState(false);
  const [studentProfile, setStudentProfile] = useState(null);
  const [fetchingProfile, setFetchingProfile] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [faydaLoading, setFaydaLoading] = useState(false);
  const [examCenters, setExamCenters] = useState([]);
  const navigate = useNavigate();
  const recaptchaRef = useRef(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const address = userInfo?.address || {};
  const profilePicture = userInfo?.picture || '';
  const [savingFayda, setSavingFayda] = useState(false);  
  const [registrationStatus, setRegistrationStatus] = useState('Opends'); // default = closed
  const [stepLoading, setStepLoading] = useState(false);
   const [isSaving, setIsSaving] = useState(false);
   const [showNotice, setShowNotice] = useState(false);

   const [savingExamCenter, setSavingExamCenter] = useState(false);


   useEffect(() => {
    const fetchExamCenters = async () => {
      try {
        const res = await axios.get('https://exam.ethernet.edu.et/api/get-examcenters');
        setExamCenters(res.data || []);
      } catch (error) {
        console.error('Failed to fetch exam centers:', error);
      }
    };
  
    fetchExamCenters();
  }, []);
  

  
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await axios.get('https://exam.ethernet.edu.et/api/registration-status');
         if (res.data && res.data.status) {
          setRegistrationStatus(res.data.status);  
        } else {
         }
      } catch (error) {
       }
    };
  
    fetchStatus();
  }, []);
  
  
  
  useEffect(() => {
    
  
    const handleFaydaCallback = async () => {
      console.log('🟡 Fayda callback handler started');
  
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const codeVerifier = localStorage.getItem('fayda_code_verifier');
      const savedUsername = localStorage.getItem('exit_username');
  
  
  
      if (!code || !codeVerifier) {
        console.warn(' Missing code or codeVerifier — skipping callback');
        return;
      }
  
      if (!savedUsername) {
        console.warn('Username not found — going back to Step 1');
        setSnackbar({ open: true, message: 'Username missing. Please start again.', severity: 'error' });
        setActiveStep(0);
        return;
      }
  
      setLoading(true);
  
      try {
        
        // Step 2: Fayda token exchange
        const faydaRes = await axios.get('https://exam.ethernet.edu.et/api/auth/callback', {
          params: { code, code_verifier: codeVerifier },
          timeout: 25000,
        });
        console.log('✅ Fayda profile fetched:', faydaRes.data);
        setUserInfo(faydaRes.data.user || {});
        setActiveStep(2);
  
        setSnackbar({
          open: true,
          message: 'Fayda profile verified successfully!',
          severity: 'success',
        });
      } catch (err) {
        console.error('❌ Fayda callback error:', err);
        setError('Verification failed: ' + (err.message || 'Unknown error'));
        setSnackbar({
          open: true,
          message: err.message || 'Fayda verification failed. Try again.',
          severity: 'error',
        });
        setActiveStep(0);
      } finally {
        setLoading(false);
      }
    };
  
    const delay = setTimeout(() => {
      handleFaydaCallback();
    }, 300);
  
    return () => clearTimeout(delay);
  }, []);
  
  
  
  
 
  const handleNext = async () => {
    const savedUsername = localStorage.getItem('exit_username');
  
    setStepLoading(true); // 🔁 start loading
  
    try {
      const recaptchaToken = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
  
      const res = await axios.post('https://exam.ethernet.edu.et/api/get-record', {
        username: savedUsername,
        recaptcha_token: recaptchaToken,
      });
  
      setStudentProfile(res.data);
  
      if (res.data?.is_paid === 1) {
        navigate('/');
        return;
      }
  
      setActiveStep((prev) => prev + 1);
    } catch (err) {
      console.error('Failed to fetch student profile', err);
      setSnackbar({
        open: true,
        message: 'Something went wrong. Please try again.',
        severity: 'error',
      });
    } finally {
      setStepLoading(false); // 🔁 end loading
    }
  };
  
  
  
  const handleFinish = () => {
    console.log('Finishing... removing localStorage and navigating');
    localStorage.removeItem('exit_username');
  
    setTimeout(() => {
      console.log('Clearing profile and navigating now...');
      setStudentProfile(null);
      navigate('/', { replace: true });
    }, 100);
  };
  
  
  const handleBack = () => {
    if (studentProfile?.is_paid === 1) {
      navigate('/'); // redirect to homepage
      return;
    }
    setActiveStep((prev) => prev - 1);
  };
  
  const handleSignIn = () => {;
    setFaydaLoading(true); // show spinner and disable button
  
    const codeVerifier = uuidv4() + uuidv4();
    const codeChallenge = Base64.stringify(sha256(codeVerifier));
    localStorage.setItem('fayda_code_verifier', codeVerifier);
  
      const CLIENT_ID = 'fayda-partner-moe-api';
     const REDIRECT_URI = 'https://exam.ethernet.edu.et/registration';
     const AUTHORIZATION_ENDPOINT = 'https://auth.fayda.et/authorize';

      // const CLIENT_ID = '419258';
      //  const REDIRECT_URI = 'http://localhost:3000/callback';
      //  const AUTHORIZATION_ENDPOINT = 'https://esignet.ltsstaging.fayda.et/authorize';
     const SCOPE = 'openid profile email';
     const STATE = uuidv4();
     const ACR_VALUES = 'mosip:idp:acr:generated-code:biometrics'

  
    const claims = {

      userinfo: {
        
        name: { essential: true },
        phone_number: { essential: true },
        email: { essential: true },
        picture: { essential: true },
        gender: { essential: true },
        birthdate: { essential: true },
        address: { essential: true },
      },
    };
  
    const encodedClaims = encodeURIComponent(JSON.stringify(claims));
  
    const authUrl = `${AUTHORIZATION_ENDPOINT}?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(
      REDIRECT_URI
    )}&scope=${encodeURIComponent(SCOPE)}&state=${STATE}&code_challenge=${codeChallenge}&code_challenge_method=S256&acr_values=${ACR_VALUES}&claims=${encodedClaims}`;
  
    // Redirect after short delay
    setTimeout(() => {
      window.location.href = authUrl;
    }, 300); // small delay for UX
  };


 
  
  if (loading) {
    return (
      <ThemeProvider theme={defaultTheme}>
        <div className="page-container">
          <CssBaseline />
          


          <Container component="main" sx={{ maxWidth: 'lg', minHeight: '80vh' }}>
            <Box textAlign="center" sx={{ mt: 10 }}>
              <CircularProgress />
              <Typography variant="h6" sx={{ mt: 3 }}>Fetching your Fayda profile...</Typography>
            </Box>
          </Container>
          <Footer />
        </div>
      </ThemeProvider>
    );
  }
  

  return (

    

    <ThemeProvider theme={defaultTheme}>
             
      <div className="page-container">
        <CssBaseline />

        <ReCAPTCHA
  sitekey="6LepLRQrAAAAAGsabsOe4cjcNnm61WG8fuFvuIUq"
  size="invisible"
  ref={recaptchaRef}
  asyncScriptOnLoad={() => console.log('✅ reCAPTCHA script loaded')}
  onErrored={() => console.error('❌ reCAPTCHA failed to load')}
  onExpired={() => console.warn('⚠️ reCAPTCHA expired')}
/>

        <AppBar position="static">
          <Toolbar>
            <img src={logo} alt="Ministry of Education Logo" style={{ maxHeight: '70px', marginRight: '20px' }} />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Ministry of Education
            </Typography>
          </Toolbar>
        </AppBar>
     
        <Container component="main" sx={{ maxWidth: 'lg', minHeight: '80vh' }}>
          <Typography component="h1" variant="h5" align="center" sx={{ mt: 6 }}>
            Ethiopian University Exit Exam (EUEE) Registration
          </Typography>

       



            {/* Registration Closed Notice */}
            {registrationStatus === 'Closed' && (
              <Paper
                elevation={3}
                sx={{
                  mt: 6,
                  p: 4,
                  backgroundColor: '#fff3e0',
                  borderLeft: '6px solid #ff9800',
                  maxWidth: 700,
                  mx: 'auto',
                  textAlign: 'center',
                }}
              >

             
                <Typography variant="h6" color="warning.main" sx={{ fontWeight: 'bold' }}>
                  🚧 Registration is Currently Closed
                </Typography>
                <Typography variant="body1" sx={{ mt: 1 }}>
                  The registration for the <strong>National Exit Exam</strong> has not yet opened.
                  <br />
                  Please check back soon or follow updates from the Ministry of Education.
                </Typography>
              </Paper>
            )}



          {registrationStatus === 'Open' && (
                <>


<Paper
  elevation={2}
  sx={{
    mt: 1,
    mx: 'auto',
    px: 1,
    py: 2,
    backgroundColor: '#e8f5e9',
    borderLeft: '5px solid #2e7d32',
    maxWidth: 800,
    textAlign: 'center',
  }}
>
  <Typography variant="body1" sx={{ color: '#1b5e20', fontWeight: 500 }}>
    This form is for students who took the previous Exit Exam and are registering to retake it.
  </Typography>
  <Typography component="p" align="center" sx={{ mt: 2 }}>
            Follow Registration guide <a href="https://youtu.be/C9KkQ9AHd2o">here (Video)</a>
          </Typography>
</Paper>

<>
    <Paper
      elevation={2}
      sx={{
        mt: 4,
        mb: 1,
        px: 2,
        py: 1.5,
        backgroundColor: '#fff8e1',
        borderLeft: '5px solid #fbc02d',
        maxWidth: 800,
        mx: 'auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={() => setShowNotice((prev) => !prev)}
    >
      <Typography sx={{ color: '#795548', fontWeight: 500 }}>
      📌 Special Notice for Jigjiga University Candidates – Click to View
      </Typography>
      <IconButton>
        <InfoIcon sx={{ color: '#f57c00' }} />
      </IconButton>
    </Paper>

    <Collapse in={showNotice} timeout="auto" unmountOnExit>
      <Paper
        elevation={0}
        sx={{
          backgroundColor: '#fffde7',
          borderLeft: '5px solid #fbc02d',
          px: 3,
          py: 2,
          maxWidth: 800,
          mx: 'auto',
          mb: 2,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-line', color: '#4e342e' }}>
            ለጅግጅጋ ዩኒቨርሲቲ የመውጫ ፈተና ማዕከል ድጋሚ ተፈታኞች በሙሉ፡{'\n\n'}
            በባለፈው የመውጫ ፈተና በዲሲፕሊን ምክንያት ውጤታችሁ መሰረዙ ይታወሳል። ሆኖም ግን በሰኔ 2017 ዓ.ም ለሚሰጠው ፈተና መውሰድ እንድትችሉ የምዝገባ ዝርዝራችሁን ወደ ሲስተም ሲዘዋወር/migrate ሲደረግ/ ለተወሰኑ ደቂቃዎች ውጤታችሁ በማየታችሁ እንደተለቀቀላችሁ በመገመት ለጅግጅጋ ዩኒቨርሲቲ ማመልከታችሁ ለማወቅ ተችሏል።{'\n\n'}
            ስለሆነም የተፈጠረው ስህተት በሲስተም ምክንያት መሆኑን እያሳወቅን ለተፈጠረው ችግር ይቅርታ እየጠየቅን ፈተናውን በድጋሚ እንድትወስዱ ምዝገባ ማድረግ የምትችሉ መሆኑን እንገልጻለን።
          </Typography>
          <IconButton onClick={() => setShowNotice(false)}>
            <CloseIcon sx={{ color: '#f57c00' }} />
          </IconButton>
        </Box>
      </Paper>
    </Collapse>
  </>


              
            <Stepper activeStep={activeStep} alternativeLabel sx={{ mt: 5 }}>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* Step 1: Username */}


 
          {activeStep === 0 && (
  <>
    {/* Loader while fetching from backend */}
    {fetchingProfile && (
      <Paper elevation={3} sx={{ mt: 6, p: 4, maxWidth: 600, mx: 'auto', textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>Fetching your profile...</Typography>
      </Paper>
    )}

    {/* Show username input only when no profile and not fetching */}
    {!fetchingProfile && !studentProfile && (
      <Paper elevation={3} sx={{ mt: 6, mb: { xs: 12, sm: 10 }, p: 4, maxWidth: 700, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
          Step 1: Enter Your Username
        </Typography>

        <Divider sx={{ my: 2 }} />

            <Typography variant="body1" sx={{ mb: 2 }}>
            Your username is the unique ID from your university, used in previous years — such as , <strong>EUEE00000123</strong>.  
            It identifies you in the national exam system. Make sure you enter the correct one to proceed.
            </Typography>

        <TextField
          fullWidth
          label="Username"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={{ mb: 2 }}
        />

           <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Forgot your username? <Link href="/forgot-username" underline="hover">Click here to recover</Link>
           </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }} >  
        Completed payment ?<Link href="/update-preference" underline="hover"> Click here to manage your profile </Link> 
 
        </Typography>
     
        {fetchError && (
  <div style={{ color: 'red', marginTop: '1rem' }}>
    {fetchError.error}
    {fetchError.link_html && (
      <div
        style={{ marginTop: '0.5rem' }}
        dangerouslySetInnerHTML={{ __html: fetchError.link_html }}
      />
    )}
  </div>
)}

        <Box sx={{ mt: 2, textAlign: 'right' }}>
        <Button
  variant="contained"
  disabled={!username}
  onClick={async () => {
    setFetchingProfile(true);
    setFetchError('');

    try {
      // Run reCAPTCHA first
      // const recaptchaToken = await recaptchaRef.current.executeAsync();
      // recaptchaRef.current.reset();

      const res = await axios.post('https://exam.ethernet.edu.et/api/get-record', {
        username,
       // recaptcha_token: recaptchaToken, 
      });

      setStudentProfile(res.data);
      localStorage.setItem('exit_username', username);
    } catch (err) {
      setFetchError(err.response?.data || { error: 'Failed to fetch record.' });
      setStudentProfile(null);
    } finally {
      setFetchingProfile(false);
    }
  }}
>
  {fetchingProfile ? 'Please wait...' : 'Next'}
</Button>

        </Box>
      </Paper>
    )}

    {/* Profile Preview Block */}
    {studentProfile && (
      <Paper elevation={3} sx={{ mt: 6, p: 4, maxWidth: 800, mx: 'auto', mb: 8 }}>
        <Typography variant="h6" align="center" gutterBottom>
        🎓 Confirm Your Academic Profile
        </Typography>

        <Divider sx={{ my: 2 }} />

        <List>
      <ListItem>
        <ListItemIcon><AccountCircleIcon color="primary" /></ListItemIcon>
        <ListItemText primary="Full Name" secondary={`${studentProfile.firstname} ${studentProfile.lastname} ${studentProfile.grand_father_name}`} />
      </ListItem>
      <ListItem>
        <ListItemIcon><BadgeIcon color="primary" /></ListItemIcon>
        <ListItemText primary="Username" secondary={studentProfile.username} />
      </ListItem>
      <ListItem>
        <ListItemIcon><WcIcon color="primary" /></ListItemIcon>
        <ListItemText primary="Gender" secondary={studentProfile.gender} />
      </ListItem>
      <ListItem>
        <ListItemIcon><AccountBalanceIcon color="primary" /></ListItemIcon>
        <ListItemText primary="University" secondary={studentProfile.university?.name || 'N/A'} />
      </ListItem>
      <ListItem>
      
        <ListItemIcon><CorporateFareIcon color="primary" /></ListItemIcon>
        <ListItemText primary="Department" secondary={studentProfile.department?.name || 'N/A'} />
      </ListItem>
      <ListItem>
        <ListItemIcon><HomeIcon color="primary" /></ListItemIcon>
        <ListItemText primary="Exam Center" secondary={studentProfile.examcenter?.name || 'N/A'} />
      </ListItem>
      <ListItem>
        <ListItemIcon><PhoneIcon color="primary" /></ListItemIcon>
        <ListItemText primary="Phone Number" secondary={studentProfile.phone_no || 'N/A'} />
      </ListItem>
      <ListItem>
        <ListItemIcon>< AlternateEmailIcon   color="primary" /></ListItemIcon>
        <ListItemText primary="Email" secondary={studentProfile.email || 'N/A'} />
  </ListItem>

          {/* New item for registration status */}
          <ListItem>
            <ListItemIcon><AppRegistrationIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary="Registration Status"
              secondary={studentProfile.is_paid === 1 ? '✅ Completed' : '❌ Incomplete'}
            />
          </ListItem>
        </List>


            {studentProfile.is_paid === 1 ? (
            <Box
          sx={{
            mt: 3,
            p: 2,
            borderRadius: 2,
            backgroundColor: '#e0f2f1',
            border: '1px solid #b2dfdb',
          }}
        >
          <Typography variant="h6" sx={{ color: 'success.main', fontWeight: 'bold', mb: 1 }}>
            🎉 Registration Completed
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            You have successfully completed your registration for the upcoming <strong>National Exit Exam</strong>.
            <br />
            If you wish to update your exam preferences, you can do so by clicking the link below.
          </Typography>
          <Box sx={{ mt: 2 }}>
 
            <Link href="update-preference" underline="hover" sx={{ fontWeight: 500 }}>
              ✏️ Update My Preferences
            </Link>
          </Box>
        </Box>

    ) : (
      <Typography sx={{ mt: 2, color: 'warning.main' }}>
        If this is not your record, click Back. Otherwise, confirm to continue.
      </Typography>
    )}

    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
      <Button variant="contained" color="primary" onClick={() => setStudentProfile(null)}>
        Back
      </Button>
     <Button
  variant="contained"
  color="primary"
  disabled={studentProfile.is_paid === 1 || stepLoading}
  onClick={handleNext}
  startIcon={stepLoading ? <CircularProgress color="inherit" size={18} /> : null}
>
  {stepLoading ? 'Loading...' : 'Continue'}
</Button>

    </Box>
  </Paper>
)}

  </>
)}



          {/* Step 2: Fayda Auth */}
          {activeStep === 1 && (
            <>
              <Paper elevation={3} sx={{ mt: 6, p: 4, maxWidth: 600, mx: 'auto', textAlign: 'center' }}>
                <Box sx={{ textAlign: 'left' }}>
                  <Typography variant="h6" gutterBottom>Step 2: Verify Your Fayda ID</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ textAlign: 'left' }}>
                  <Typography sx={{ mb: 2 }}>
                    To continue with your re-examination registration, please verify your National ID.
                  </Typography>
                  <Typography sx={{ mb: 6 }}>
                    You’ll be securely redirected to <strong>Fayda</strong> to confirm your identity. Please click the button below to begin the verification process.
                  </Typography>
                </Box>

                  <Button
            variant="contained"
            disabled={faydaLoading}
            onClick={handleSignIn}
            startIcon={faydaLoading ? <CircularProgress size={20} /> : null}
          >
            {faydaLoading ? 'Redirecting...' : 'Authenticate with Fayda'}
          </Button>
              </Paper>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', maxWidth: 600, mx: 'auto', mt: 2 }}>
                <Button variant="contained" color="primary" onClick={handleBack}>Back</Button>
              </Box>
            </>
          )}

        {/* Step 3: Review Fayda Profile */}
{activeStep === 2 && (
  <>
    <Paper elevation={3} sx={{ mt: 6, p: 4, maxWidth: 800, mx: 'auto', mb: 6 }}>
      {loading ? (
        <Box textAlign="center">
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>Fetching your Fayda profile...</Typography>
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : savingFayda ? (
        <Box textAlign="center">
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>Saving your profile...</Typography>
        </Box>
      ) : (
        <>
          <Typography variant="h6" align="center" gutterBottom>
            Review Fayda Profile
          </Typography>
          <Typography align="center" color="warning.main" sx={{ mb: 2 }}>
            If this is not your profile, please do not continue.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ width: '70%' }}>
              <List>
                <ListItem><ListItemIcon><AccountCircleIcon color="primary" /></ListItemIcon><ListItemText primary="Name" secondary={userInfo.name} /></ListItem>
                <ListItem><ListItemIcon><CalendarTodayIcon color="primary" /></ListItemIcon><ListItemText primary="Birthdate" secondary={userInfo.birthdate} /></ListItem>
                <ListItem><ListItemIcon><WcIcon color="primary" /></ListItemIcon><ListItemText primary="Gender" secondary={userInfo.gender} /></ListItem>

                <ListItem><ListItemIcon><PhoneIcon color="primary"/></ListItemIcon><ListItemText primary="Phone" secondary={userInfo.phone_number
                } /></ListItem>
                 <ListItem><ListItemIcon><HomeIcon color="primary"/></ListItemIcon><ListItemText primary="Address" secondary={`Region: ${address.region}, Zone: ${address.zone}, Woreda: ${address.woreda}, Kebele: ${address.kebele}`} /></ListItem>
              </List>
            </Box>
            {profilePicture && (
  <Box sx={{ width: '25%', display: 'flex', justifyContent: 'center' }}>
    <Box
      component="img"
      src={profilePicture}
      sx={{ width: 120, height: 120, borderRadius: 2 }} // or borderRadius: 0 for sharp corners
    />
  </Box>
)}

          </Box>

          <Divider sx={{ my: 3 }} />

          <FormControlLabel
            control={
              <Checkbox
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
                color="primary"
              />
            }
            label="I hereby confirm that the above profile matches my educational identity and consent to proceed."
          />
        </>
      )}
    </Paper>

    {/* Buttons outside the paper */}
    {!loading && !error && !savingFayda && (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', maxWidth: 800, mx: 'auto', mb: 6 }}>
        <Button variant="contained" color="primary" onClick={handleBack} disabled={savingFayda}>
          Back
        </Button>
 

<Button
  variant="contained"
  color="primary"
  disabled={!consentChecked || isSaving}
  onClick={async () => {
    if (isSaving) return; // extra safeguard
    setIsSaving(true);
    try {
      const username = localStorage.getItem('exit_username');

      // Save Fayda profile
      await axios.post('https://exam.ethernet.edu.et/api/save-fayda-profile', {
        username,
        sub: userInfo.sub,
        name: userInfo.name,
        gender: userInfo.gender,
        birthdate: userInfo.birthdate,
        phone_number: userInfo.phone_number || null,
        email: userInfo.email_address || null,
        picture: userInfo.picture || null,
        address: userInfo.address || {},
      });

      // Small timeout for UI transition smoothness
      setTimeout(() => {
        handleNext();
      }, 200);
    } catch (err) {
      alert('Failed to save Fayda profile. Please try again.');
      setIsSaving(false); // Only allow retry on error
    }
  }}
  startIcon={isSaving ? <CircularProgress size={18} color="inherit" /> : null}
>
  {isSaving ? 'Saving...' : 'This is my profile, continue'}
</Button>



  {savingFayda && (
    <CircularProgress
      size={24}
      sx={{
        color: 'primary.main',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-12px',
        marginLeft: '-12px',
      }}
    />
  )}

      </Box>
    )}
  </>
)}




{activeStep === 3 && (
  <Paper elevation={3} sx={{ mt: 6, p: 4, maxWidth: 600, mx: 'auto' }}>
    <Typography variant="h6" gutterBottom>
      Step 4: Update Your Preference
    </Typography>
    <Divider sx={{ my: 2 }} />
    <Typography variant="body1" sx={{ mb: 2 }}>
      Select exam center to which you want to take the exam
    </Typography>

    <TextField
      select
      fullWidth
      label="Exam Center"
      value={userInfo.examcenter}
      onChange={(e) => setUserInfo({ ...userInfo, examcenter: e.target.value })}
      sx={{ mb: 2 }}
    >
      <MenuItem value="">Select Exam Center</MenuItem>
      {examCenters.map((center) => (
        <MenuItem key={center.id} value={center.id}>
          {center.name}
        </MenuItem>
      ))}
    </TextField>

    {/* Saving indicator and error message */}
    {faydaLoading && (
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <CircularProgress size={20} sx={{ mr: 1 }} />
        <Typography>Saving your preference...</Typography>
      </Box>
    )}

{fetchError && (
  <Alert
    severity="error"
    variant="outlined"
    sx={{ mb: 2 }}
    onClose={() => setFetchError('')}
  >
    <span dangerouslySetInnerHTML={{ __html: fetchError }} />
  </Alert>
)}

    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button variant="contained" onClick={handleBack} disabled={faydaLoading}>
        Back
      </Button>

<Button
  variant="contained"
  color="primary"
  disabled={!userInfo.examcenter || savingExamCenter}
  onClick={async () => {
    if (savingExamCenter) return; // safeguard against double click
    setSavingExamCenter(true);
    setFetchError('');
    try {
      const username = localStorage.getItem('exit_username');

       const recaptchaToken = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();

       await axios.post('https://exam.ethernet.edu.et/api/save-examcenter-KISGHAKNE42243MSSG', {
        username,
        examcenter_id: userInfo.examcenter,
        recaptcha_token: recaptchaToken,
      });

       setTimeout(() => {
        handleNext();
      }, 200);
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        'Failed to save exam center.';
      setFetchError(msg);
      setSavingExamCenter(false); // allow retry on error
    }
  }}
  startIcon={savingExamCenter ? <CircularProgress size={18} color="inherit" /> : null}
>
  {savingExamCenter ? 'Saving...' : 'Continue'}
</Button>

    </Box>
  </Paper>
)}


          {/* Step 5 */}
          {/* Step 5: Complete Registration */}
          {activeStep === 4 && (
  <Paper elevation={3} sx={{ mt: 6, mb: 10, p: 4, maxWidth: 700, mx: 'auto' }}>
    <Typography variant="h5" gutterBottom align="center">
      Step 5: Complete Payment and Registration
    </Typography>

    <Divider sx={{ my: 2 }} />

    <Typography variant="body1" sx={{ mb: 3 }} align="center" color="warning.main">
      ⚠️ Your registration is <strong>not complete</strong> until you finish the payment.
    </Typography>

    <Box
  sx={{
    p: 3,
    borderRadius: 2,
    backgroundColor: '#fefefe',
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
    mb: 4,
  }}
>
  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
    📄 Payment Summary
  </Typography>

  <Divider sx={{ mb: 2 }} />

  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
    <Typography sx={{ width: 160 }} color="text.secondary">Payer Name:</Typography>
    <Typography>
      {studentProfile?.firstname} {studentProfile?.lastname} {studentProfile?.grand_father_name}
    </Typography>
  </Box>
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
    <Typography sx={{ width: 160 }} color="text.secondary">Payment Method:</Typography>
    <Typography>Telebirr</Typography>
  </Box>

  

  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
    <Typography sx={{ width: 160 }} color="text.secondary">Reference Number:</Typography>
    <Typography fontWeight="bold" sx={{ letterSpacing: 1 }}>{studentProfile?.reference_number || 'N/A'}</Typography>
    </Box>

  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Typography sx={{ width: 160 }} color="text.secondary">Service Fee:</Typography>
    <Typography fontWeight="bold" color="success.main">500 ETB</Typography>
  </Box>
</Box>




    <Card variant="outlined" sx={{ mb: 4 }}>
      <CardContent>
 
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
        📱 Payment Instructions
  </Typography>
        <Box component="ol" sx={{ pl: 3, textAlign: 'left', lineHeight: 2 }}>
          <li>Open the <strong>Telebirr</strong> mobile app</li>
          <li>Tap <strong>Payment</strong></li>
          <li>Select <strong>Education Fee</strong></li>
          <li>Choose <strong>Ministry of Education</strong></li>
          <li>Enter the reference number: <strong>{studentProfile?.reference_number || 'N/A'}</strong></li>
          <li>Confirm amount and your details</li>
          <li>Enter your PIN and complete the payment</li>
        </Box>
        <Typography sx={{ mt: 2 }}>
          📩 Once payment is done, you'll receive an SMS. Save the  <strong>transaction number</strong> — you’ll need it to update your profile.
        </Typography>

        <Typography sx={{ mt: 2 }}>
  ✅ After payment completion you can check your registration status by clicking<Link
    href="/update-preference"
    underline="hover"
    sx={{ fontWeight: 500, ml: 1 }}
  >here
  </Link> and provide your username
</Typography>

      </CardContent>
    </Card>

    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
  <Button variant="contained" onClick={() => setActiveStep(activeStep - 1)}>
    Back
  </Button>

  <Button variant="contained" color="success"  onClick={handleFinish}>
    Finish
  </Button>
</Box>

  </Paper>
)}
 


          </>
          )}
        </Container>

        <Footer />
     
      </div>
    </ThemeProvider>
  );
}
